import { isMobileStandaloneBrowser } from 'signup-ui-lego-core/utils/isMobileStandaloneBrowser';
export const isGoogleSignupSupported = () => {
  return !isMobileStandaloneBrowser();
};